/*
 * @Description: 特殊付款申请（PO）
 */
import { RootObject } from '@/model/rootObject'
import https, { downloadExcel } from '@/utils/https'
import { ContentType, Method } from 'axios-mapper'
import {
  CreatePORequestModel, POSelectedResultModel, PORequestIdListModel,
  PORequestListParamModel,
  PORequestModel, PORequestPageModel, PORequestPageParamModel, PORequestSetPaymentDateModel,
  UpdatePORequestModel, POSetPurposeParamModel

} from '@/model/application-form/specialPaymentRequestPO'
import networkConfig from '@/config/default/net.config'

const baseUrl = '/base/payment/po'

export const excelPOFileUpload = () => {
  return networkConfig.host + baseUrl + '/import/excel'
}

export const createPORequest = (params: CreatePORequestModel) => {
  return https().request<RootObject<number>>(baseUrl + '/add', Method.POST, params, ContentType.json)
}

export const updatePORequest = (params: UpdatePORequestModel) => {
  return https().request<RootObject<number>>(baseUrl + '/update', Method.POST, params, ContentType.json)
}

export const getPORequestById = (id: number) => {
  return https()
    .request<RootObject<PORequestModel>>(baseUrl + '/get/' + id, Method.GET, undefined, ContentType.json)
}

export const getPORequestPageList = (params: PORequestPageParamModel) => {
  return https().request<RootObject<PORequestPageModel>>(baseUrl + '/list', Method.POST, params, ContentType.json)
}

export const getPORequestPageListByUser = (params: PORequestPageParamModel) => {
  return https().request<RootObject<PORequestPageModel>>(baseUrl + '/listByUser', Method.POST, params, ContentType.json)
}

export const getPORequestAllList = (params: PORequestListParamModel) => {
  return https().request<RootObject<PORequestModel[]>>(baseUrl + '/list/all', Method.POST, params, ContentType.json)
}

export const setPORequestPaymentDate = (params: PORequestSetPaymentDateModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/set/paymentDate', Method.POST, params, ContentType.json)
}

export const generatePOApprovalForms = (params: PORequestIdListModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/generate/approvalForms', Method.POST, params, ContentType.json)
}

export const getPORequestByIds = (params: PORequestIdListModel) => {
  return https()
    .request<RootObject<POSelectedResultModel[]>>(baseUrl + '/get/selectedApprovalForms', Method.POST, params, ContentType.json)
}
export const cancelPOApplication = (params: PORequestIdListModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/cancel/application', Method.POST, params, ContentType.json)
}

export const setPOSetPurpose = (params: POSetPurposeParamModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/set/purpose', Method.POST, params, ContentType.json)
}

export const exportPOTemplate = () => {
  return downloadExcel(baseUrl + '/export/excelTemplate', Method.GET, undefined)
}
